import { render } from "./NotFoundPage.vue?vue&type=template&id=11d0a5ae"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=11d0a5ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__